{
  "my_calendar": {
    "upcoming": "À venir",
    "recent": "Récent",
    "calendar": "Calendrier",
    "list": "Liste",
    "with": "Avec",
    "edit_key_activity": "Modifier l'activité clé",
    "mark_as_bd_activity": "Marquer comme activité de développement commercial",
    "empty_state": {
      "no_meetings_alt": "Aucune réunion ou activité",
      "no_meetings_title": "Aucune réunion ou activité",
      "no_events_scheduled": "Vous n'avez aucun événement programmé."
    },
    "load_more": {
      "upcoming_complete": "C'est tout pour les événements du mois à venir.",
      "past_complete": "C'est tout pour les événements des 3 derniers mois."
    }
  }
}
